export default __webpack_public_path__ + "static/media/thumbnail.1f9cec91.png";